import React from 'react';
import { Link } from 'react-router-dom';
import { BaseModal } from './BaseModal';

interface DoNotSellModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function DoNotSellModal({ isOpen, onClose }: DoNotSellModalProps) {
  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      title="Do Not Sell My Data"
    >
      <div className="space-y-4 text-gray-600 dark:text-gray-300">
        <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-xl p-4 mb-6">
          <p className="text-yellow-800 dark:text-yellow-200 text-sm">
            This is a test website for demonstration purposes only. The information below is an example of how data selling preferences might be described.
          </p>
        </div>

        <p>
          Certain states (such as CA, CO, CT, VA, UT) provide consumers the right to opt out of certain 
          sharing, uses, or disclosures of data. While we do not sell your demographic or contact data, 
          we may make certain sharing, uses, or disclosures of your data as described in our Online Privacy 
          and Security Policy, which may be considered a sale under certain state laws.
        </p>

        <p>
          Consumer requests to opt out of the sale of data can be made at the{' '}
          <Link 
            to="/privacy"
            className="text-[#5e9bb8] hover:text-[#499da8] dark:text-[#5e9bb8] dark:hover:text-[#499da8] transition-colors duration-200"
            onClick={onClose}
          >
            Data Preferences page
          </Link>
          {' '}or by contacting us at 800-925-4733.
        </p>

        <div className="mt-6">
          <Link 
            to="/privacy"
            className="text-[#5e9bb8] hover:text-[#499da8] dark:text-[#5e9bb8] dark:hover:text-[#499da8] transition-colors duration-200"
            onClick={onClose}
          >
            For more information, please visit our Online Privacy & Security Policy page
          </Link>
        </div>
      </div>
    </BaseModal>
  );
}